import { h, render } from 'preact';
import { useState } from 'preact/hooks';
import ProductGallery from './product-gallery';
import ProductForm from './product-form';
import Badge from '../utils/badge';
import ProductStyleItWith from './product-style-it-with';
import Breadcrumbs from '../utils/breadcrumbs';
import ProductEngraving from './product-engraving';
import ProductDetailsTray from './product-details-tray';
import ProductDetailsPanel from './product-details-panel';
import ProductSpecs from './product-specs';
import saveViewedProduct from './saveViewedProduct';

export default (element, data) => {
  const Product = (props) => {
    const [openDetailsEls, setOpenDetailsEls] = useState([]);
     
    const addOpenDetailsEl = (e) => {
      setOpenDetailsEls((openDetailsElems) => [
        ...openDetailsElems,
        e.current,
      ]);
    };

    return (
      <div className='relative'>
        <div 
          className='flex flex-col md:flex-row'
          data-target='product-container'
        > 
          <div className='md:w-2/4 lg:w-[calc(100%_-_45.375rem)] relative' data-target='pdp-gallery-column'>
            <div className='relative h-full'>
              <div className={`h-full overflow-auto`} data-target='gallery-container' data-total-media={`${props?.product?.media?.length}`}>
                <Badge {...props} />
                <ProductGallery {...props} />
              </div>
            </div>
          </div>
          <div className='md:w-2/4 lg:min-w-[45.375rem] relative' data-target='pdp-form-column'>
            <div className='m-auto md:pb-[7rem] py-5 px-[18px] lg:px-0 lg:py-10 lg:w-[45.375rem] lg:pb-[13.75rem]' data-target='form-column-container'>
              <div className='w-[27.375rem] max-w-full mx-auto'>
                <Breadcrumbs {...props} />
                <ProductForm {...props} />
                <ProductDetailsTray 
                  addOpenDetailsEl={addOpenDetailsEl} {...props} 
                />
                <ProductStyleItWith {...props} />
                <ProductSpecs fromForm={true} {...props} />
              </div>
            </div>
            <ProductDetailsPanel 
              openTriggerElArray={openDetailsEls} {...props} 
            /> 
          </div>
        </div>
        <ProductEngraving {...props}/>
      </div>
    );
  };
  
  const init = () => { 
    // Call the function to save the product on page load
    saveViewedProduct(data);

    render(<Product {...data} />, element); 
  };

  init();
}; 
